class Permissions {
  constructor() {
    // Write permissions
    this.writePermissions = {
      quality: ["booking", "ride", "holiday", "backup", "captain"],
      marketing: ["promotion", "credit", "tag"],
      support: ["booking", "user", "topup"],
      supply: [
        "bus",
        "bustype",
        "captain",
        "company",
        "corporate",
        "route",
        "station",
        "schedule",
        "reservation",
        "tag",
      ],
      admin: [
        "bus",
        "bustype",
        "captain",
        "company",
        "corporate",
        "ride",
        "route",
        "booking",
        "booking-listing",
        "promotion",
        "credit",
        "topup",
        "district",
        "city",
        "user",
        "schedule",
        "station",
        "basicPlan",
        "backupPlan",
        "deductionPlan",
        "variablePlan",
        "holiday",
        "backup",
        "backupschedule",
        "reservation",
        "tag",
        "bonuses",
      ],
    };
  }
}

export default Permissions;



// WEBPACK FOOTER //
// ./src/services/permissions/permissions.service.js